import {sysUtil} from "jscom/utils/sysutil"

export class CacheUtil {
  static setRedirectUrl (url) {
    sysUtil.setLocalStore('redirectUrl', url, true)
  }

  static getRedirectUrl () {
    let url = sysUtil.getLocalStore('redirectUrl', true)
    if (url) {
      sysUtil.removeLocalStore('redirectUrl', true)
    }
    return url
  }

  static setWxUserInfo (wxUserInfo) {
    sysUtil.setLocalStore('wxUserInfo', wxUserInfo, true)
  }

  static getWxUserInfo () {
    let userInfo = sysUtil.getLocalStore('wxUserInfo', true)
    if (userInfo) {
      sysUtil.removeLocalStore('wxUserInfo', true)
      userInfo = JSON.parse(userInfo)
    }
    return userInfo
  }

  static setIsLogout (isLogout) {
    sysUtil.setLocalStore('isLogout', isLogout, true)
  }

  static getIsLogout () {
    let isLogout = sysUtil.getLocalStore('isLogout', true)
    if (isLogout) {
      return JSON.parse(isLogout)
    }
    return false
  }

  static setBatchOrder (batchOrder) {
    if (!batchOrder) {
      sysUtil.removeLocalStore('batchOrder', true)
    } else {
      sysUtil.setLocalStore('batchOrder', batchOrder, true)
    }
  }

  static getBatchOrder () {
    let batchOrder = sysUtil.getLocalStore('batchOrder', true)
    if (batchOrder) {
      return JSON.parse(batchOrder)
    }
    return null
  }

  static setToken(token) {
    if (!token) {
      sysUtil.removeLocalStore('token', true)
    } else {
      sysUtil.setLocalStore('token', token, true)
    }
  }

  static getToken() {
    return sysUtil.getLocalStore('token', true)
  }

  static setCompanyFormInfo(formInfo) {
    let companyFormInfo = sysUtil.getLocalStore('companyFormInfo')
    if (!companyFormInfo) {
      sysUtil.setLocalStore('companyFormInfo', JSON.stringify(formInfo))
    } else {
      let info = Object.assign(JSON.parse(companyFormInfo), formInfo)
      sysUtil.setLocalStore('companyFormInfo', JSON.stringify(info))
    }
  }

  static getCompanyFormInfo () {
    let companyFormInfo = sysUtil.getLocalStore('companyFormInfo')
    return JSON.parse(companyFormInfo)
  }

  static deleteCompanyFormInfo () {
    sysUtil.removeLocalStore('companyFormInfo')
  }

  static setAddCompanyItem (value) {
    let companyItem = sysUtil.getLocalStore('addCompanyItem', true)
    if (!companyItem) {
      sysUtil.setLocalStore('addCompanyItem', JSON.stringify(value), true)
    } else {
      let item = Object.assign(JSON.parse(companyItem), value)
      sysUtil.setLocalStore('addCompanyItem', JSON.stringify(item), true)
    }
  }

  static getAddCompanyItem () {
    let companyItem = sysUtil.getLocalStore('addCompanyItem', true)
    return JSON.parse(companyItem)
  }

  static deleteAddCompanyItem () {
    sysUtil.removeLocalStore('addCompanyItem', true)
  }

  static setSearchSupplierType (value) {
    if (value) {
      sysUtil.setLocalStore('searchSupplierType', {key: 'current', title: '当前供货商'})
    } else {
      sysUtil.setLocalStore('searchSupplierType', value)
    }
  }

  static getSearchSupplierType () {
    let type = sysUtil.getLocalStore('searchSupplierType')
    return JSON.parse(type)
  }

  static deleteSearchSupplierType () {
    sysUtil.removeLocalStore('searchSupplierType')
  }
}



// WEBPACK FOOTER //
// ./src/common/cacheUtil.js